/* global mw_kva_ajax_object */

$(document).on("submit", 'form.kva-calc', function(e) { 
    $('.m__kva #loading').addClass('active');
    $('.m__kva .loading-background').addClass('active');
    
    // if(!mw.form.validateForm($(this))) {
    //     return false;
    // } 

    e.preventDefault(); 

    $('#kva-result').empty();

    var filtersObj = {},
        filtersVal = $(this).serializeArray();

    var hasEmptyField = false;

    // Validate fields with data-required="true"
    $(this).find('[data-required="true"]').each(function () {
        if (!$(this).val().trim()) {
            $(this).addClass('error');
            if (!$(this).next('.error-msg').length) {
                $(this).after('<span class="error-msg">This field is required</span>');
            }
            hasEmptyField = true;
        } else {
            $(this).removeClass('error').next('.error-msg').remove();
        }
    });

    $.each(filtersVal, function (i, f) {
        if (filtersObj[f.name]) {
            filtersObj[f.name] += ',' + f.value;
        } else if (f.value) {
            filtersObj[f.name] = f.value;
        }
    }); 

    var total; 
    if ( typeof mw_kva_ajax_object.ajax_url !== 'undefined' ) {
        var ajaxPromise = $.ajax({
            type: 'POST',
            url: mw_kva_ajax_object.ajax_url,
            dataType: 'json',
            data: ({
                'action': 'ajax_kva_calc',
                'security': mw_kva_ajax_object.nonce,
                'filters': filtersObj,
            }),
            success: function (data) {
                total = data.kva;
            }
        });
        $.when(ajaxPromise).done(function (data) {
            if (hasEmptyField) {
                $('.calc-result').removeClass('active');
                $('#kva-result').hide();
            }else{
                $('#kva-result').html(total);
                $('#kva-result').show();
                $("html, body").animate(
                    {
                      scrollTop: $('#kva-result').offset().top - 120,
                    },
                    500,
                  );
                $('.calc-result').addClass('active');
                $('.calc-result').html(data.results);
            }
            $('.m__kva #loading').removeClass('active');
            $('.m__kva .loading-background').removeClass('active');
            $('#gform_' + data.form_id).attr('action', '')
        });
    }
});